import { IEstimateComparisonData } from "common/records/EstimateComparison";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const FETCH_ESTIMATE_COMPARISON = "@estimateComparison/FETCH_ESTIMATE_COMPARISON";
export const RECEIVE_ESTIMATE_COMPARISON = "@estimateComparison/RECEIVE_ESTIMATE_COMPARISON";
export const SET_ESTIMATE_COMPARISON_LOADED = "@estimateComparison/SET_ESTIMATE_COMPARISON_LOADED";
export const BUILD_ESTIMATE_COMPARISON = "@estimateComparison/BUILD_ESTIMATE_COMPARISON";
export const ADD_ESTIMATE_COMPARISON_LINK = "@estimateComparison/ADD_ESTIMATE_COMPARISON_LINK";
export const REMOVE_ESTIMATE_COMPARISON_LINK = "@estimateComparison/REMOVE_ESTIMATE_COMPARISON_LINK";
export const REMAP_ESTIMATE_COMPARISON_LINK = "@estimateComparison/REMAP_ESTIMATE_COMPARISON_LINK";
export const RESET_ESTIMATE_COMPARISON = "@estimateComparison/RESET_ESTIMATE_COMPARISON";

export const EstimateComparisonActions = {
  fetchEstimateComparison: (jobId: number) => createAction(FETCH_ESTIMATE_COMPARISON, { jobId }),
  receiveEstimateComparison: (estimateComparison: Partial<IEstimateComparisonData>) =>
    createAction(RECEIVE_ESTIMATE_COMPARISON, { estimateComparison }),
  setEstimateComparisonLoaded: (jobId: number) => createAction(SET_ESTIMATE_COMPARISON_LOADED, { jobId }),
  buildEstimateComparison: (jobId: number, estimateIds: number[]) =>
    createAction(BUILD_ESTIMATE_COMPARISON, { jobId, estimateIds }),
  addEstimateComparisonLink: (estimateId: number, jobId: number) =>
    createAction(ADD_ESTIMATE_COMPARISON_LINK, { estimateId, jobId }),
  removeEstimateComparisonLink: (estimateId: number, jobId: number) =>
    createAction(REMOVE_ESTIMATE_COMPARISON_LINK, { estimateId, jobId }),
  remapEstimateComparisonLink: (jobId: number, fromEstimateId: number, toEstimateId: number) =>
    createAction(REMAP_ESTIMATE_COMPARISON_LINK, { jobId, fromEstimateId, toEstimateId }),
  resetEstimateComparison: (jobId: number) => createAction(RESET_ESTIMATE_COMPARISON, { jobId }),
};

export type EstimateComparisonActions = ActionsUnion<typeof EstimateComparisonActions>;
